// ------------------ CREW Order Tracking ------------------ //
import { z } from 'zod';
import { TrackingStatusCode } from '../../enums/tracking.js';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
import { storeOrderLineItem } from './lineItem.js';
export const orderTrackerDetail = z.object({
    date: z.string(),
    message: z.string(),
    status: enumToZodLiteralUnion(TrackingStatusCode),
    location: z.object({
        city: z.string().nullable(),
        state: z.string().nullable(),
        country: z.string().nullable(),
        zip: z.string().nullable(),
    }),
});
export const carrier = z.object({
    iconImgUrl: z.string(),
    name: z.string(),
    trackingCode: z.string(),
    trackingUrl: z.string().nullable(),
});
export const orderTracker = z.object({
    status: enumToZodLiteralUnion(TrackingStatusCode),
    statusDetail: z.string().optional(),
    idFromPlatform: z.string(),
    carrier,
    estimatedDeliveryDate: z.string().nullable(),
    details: z.array(orderTrackerDetail),
});
// a fulfillment with several tracking numbers is several parcels, so this is one row per
// parcel and `fulfillmentId` is what groups the ones that left the warehouse together
export const orderShipment = z.object({
    id: z.number(),
    fulfillmentId: z.number(),
    fulfilledFrom: z.string().nullable(),
    tracker: orderTracker,
    lineItems: z.array(storeOrderLineItem.pick({
        id: true,
        name: true,
        sku: true,
        quantity: true,
        imgUrl: true,
        optionsFromPlatform: true,
    })),
});
export const orderShipments = z.array(orderShipment);
//# sourceMappingURL=tracking.js.map